/**
 * Toggling Old Navigation and shameful hack
 */

$(function () {

	var $body = $('body'),
		$viewport = $('meta[name=viewport]'),
		toggleResponsive = function (bypass, e) {
			if (bypass || confirm('Toggle responsive?')) {
				$body.toggleClass('res').promise().done(function () {

					var mobile = !!($body.hasClass('res'));

					$viewport.attr('content', (mobile) ? 'width=device-width,initial-scale=1,user-scalable=no' : 'width=1064,initial-scale=1');
					Cookies.set('responsive', !!($body.hasClass('res')));

					$(window).trigger('resize');

				});

				e.preventDefault();
				return false;
			}
		};

	if (Cookies.get('responsive') == 'true') {
		$('body').addClass('res');
	}

	Mousetrap.bind(['r e s', 'n n', 'm m'], function (e) {
		return toggleResponsive(true, e);
	});

	$('#navigation .logo').longpress(function (e) {
		return toggleResponsive(false, e);
	}, 100);

});